import { ICCUser } from '../notifications';

export enum CC_PERMISSIONS {
  AllNotifications = 'AllNotifications',
  MyNotifications = 'MyNotifications',
  Audiences = 'Audiences',
  PublishNotifications = 'PublishNotifications',
  Management = 'Management',
}

export enum PERM_TYPES {
  Read = 'Read',
  Write = 'Write',
}

export const permsOrder = {
  [PERM_TYPES.Read]: 1,
  [PERM_TYPES.Write]: 2,
};

export type PermissionRestriction = [CC_PERMISSIONS, PERM_TYPES] | [CC_PERMISSIONS];

export type PermissionType = PermissionRestriction | PermissionRestriction[];

export const hasRequiredPermissions = (user: ICCUser, requiredPermissions: PermissionRestriction | PermissionRestriction[]) => {
  const permArr = (Array.isArray(requiredPermissions[0]) ? requiredPermissions : [requiredPermissions]) as PermissionRestriction[];
  return permArr.some(it => {
    const permValue = user?.role?.permissions?.[it[0]];
    if (it.length === 1) {
      return !!permValue;
    }
    return !!permValue && (permsOrder[permValue] ?? -Infinity) >= permsOrder[it[1]];
  });
};

export const isAllowedToUser = ({
  user,
  allowedRoles,
  creatorsIds,
  permissions,
}: {
  user: ICCUser;
  allowedRoles?: string[];
  creatorsIds?: number[];
  permissions?: PermissionRestriction | PermissionRestriction[];
}) =>
  !user ||
  (!allowedRoles?.length && !permissions?.length) ||
  creatorsIds?.every(creatorId => creatorId === user?.id) ||
  (!!allowedRoles?.length && allowedRoles.includes(user?.role?.displayName || '')) ||
  (!!permissions?.length && hasRequiredPermissions(user, permissions));
